import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12 22a9.97 9.97 0 0 0 7.071-2.929A9.97 9.97 0 0 0 22 12a9.97 9.97 0 0 0-2.929-7.071A9.97 9.97 0 0 0 12 2a9.97 9.97 0 0 0-7.071 2.929A9.97 9.97 0 0 0 2 12a9.97 9.97 0 0 0 2.929 7.071A9.97 9.97 0 0 0 12 22"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.399 4.399A10.72 10.72 0 0 1 12 1.25c2.968 0 5.657 1.204 7.601 3.149l-.53.53.53-.53A10.72 10.72 0 0 1 22.75 12c0 2.968-1.204 5.657-3.149 7.601A10.72 10.72 0 0 1 12 22.75a10.72 10.72 0 0 1-7.601-3.149l.53-.53-.53.53A10.72 10.72 0 0 1 1.25 12c0-2.968 1.204-5.657 3.149-7.601M12 2.75a9.22 9.22 0 0 0-6.54 2.71A9.22 9.22 0 0 0 2.75 12a9.22 9.22 0 0 0 2.71 6.54A9.22 9.22 0 0 0 12 21.25a9.22 9.22 0 0 0 6.54-2.71A9.22 9.22 0 0 0 21.25 12a9.22 9.22 0 0 0-2.71-6.54A9.22 9.22 0 0 0 12 2.75",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M8.25 9.313a3.75 3.75 0 1 1 4.977 3.544.9.9 0 0 0-.375.237c-.081.09-.102.163-.102.219v1a.75.75 0 0 1-1.5 0v-1c0-1.003.808-1.639 1.486-1.874A2.251 2.251 0 1 0 9.75 9.313a.75.75 0 0 1-1.5 0M12 19.313a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }